import { useAppUpdateAvailable } from '@backoffice-frontend/common'
import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router'

export const AppUpdateToast = () => {
  const appUpdateAvailable = useAppUpdateAvailable()
  const { pathname } = useLocation()
  const previousPathnameRef = useRef(pathname)

  useEffect(() => {
    // Track every pathname change, not just those seen while an update is
    // pending — otherwise the ref goes stale and the update reloads instantly.
    const previousPathname = previousPathnameRef.current
    previousPathnameRef.current = pathname

    if (!appUpdateAvailable) return

    if (pathname === previousPathname) return

    window.location.reload()
  }, [appUpdateAvailable, pathname])

  return null
}
